import React from "react";

import connectActions from "fantastic/lib/connectActions";

import cloneId from "fantastic/actions/cloneId";
import favoriteId from "fantastic/actions/favoriteId";
import removeId from "fantastic/actions/removeId";
import editId from "fantastic/actions/editId";

const Tools = ({
  connectDragSource,
  cloneId,
  removeId,
  favoriteId,
  id,
  editId,
  meta: { removable, selected, type, kind, favoritable, editable }
}) => {
  if (!selected) return null;

  return (
    <div className="ftc-tools">
      <div className="ftc-tools__actions">
        {type === "SECTION" ||
        (type === "ITEM" && (kind === "block" || kind === "table" || kind === "html")) ? (
          connectDragSource(
            <div className="btn btn-default btn-xs">
              <i className="fa fa-arrows" />
            </div>
          )
        ) : (
          <div className="btn btn-default btn-xs">
            <i className="fa fa-arrows" />
          </div>
        )}
        <div className="ftc-tools__actions--list">
          {favoritable && (
            <div
              onClick={() => favoriteId(id)}
              className="btn btn-default btn-xs"
            >
              <i className="fa fa-star-o" />
            </div>
          )}
          {removable && (
            <>
              <div
                className="btn btn-default btn-xs"
                onClick={() => cloneId(id)}
              >
                <i className="fa fa-clone" />
              </div>
              <div
                className="btn btn-default btn-xs"
                onClick={() => removeId(id)}
              >
                <i className="fa fa-trash" />
              </div>
            </>
          )}
          {editable && (
            <div
              onClick={() => editId(id)}
              className="btn btn-default btn-xs"
            >
              <i className="fa fa-pencil" />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default connectActions({ cloneId, removeId, favoriteId, editId })(Tools);
